var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isAuth
    ? _c("auth-panel")
    : _vm.client_loading || _vm.shop_loading
    ? _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { staticClass: "text-center" },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: "90",
                      width: "3",
                      color: "dark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "sidebar-menu",
        [
          _c("router-view"),
          !["product_page"].includes(_vm.$route.name)
            ? _c("top-button")
            : _vm._e(),
          _c("blocked-dialog"),
          [
            "purchase_album_detail",
            "purchase_market",
            "purchase_clients",
          ].includes(_vm.$route.name)
            ? _c("socket", {
                attrs: {
                  name: "ClientsPurchase",
                  path: `purchases/clients/${_vm.$route.params.purchase_id}/`,
                },
                on: { onmessage: _vm.onSocketMessage },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }